var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"font-weight-bold"},[_vm._v("Your local may have more than one option available to you for paying your dues. Please work with your local to determine your payment method.")])])}
var staticRenderFns = []

export { render, staticRenderFns }